import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67494123"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submitState" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topImg" }, null, -1))
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  key: 0,
  class: "centerImg"
}
const _hoisted_5 = {
  key: 1,
  class: "iptsContent"
}
const _hoisted_6 = {
  key: 2,
  class: "bottom"
}
const _hoisted_7 = {
  key: 3,
  class: "closeImg"
}
const _hoisted_8 = {
  key: 4,
  class: "iptsContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.realName), 1),
    (_ctx.state === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.state === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "试卷已成功提交！"))
      : _createCommentVNode("", true),
    (_ctx.state === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "本次考试暂不公开考试结果，感谢您的作答！"))
      : _createCommentVNode("", true),
    (_ctx.state === 'lose')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.state === 'lose')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "试卷提交失败！"))
      : _createCommentVNode("", true)
  ]))
}